const States = {
  // Taken from window.connect object in default ccp.
  // Last updated 12-20-18
  contactStateTypes: {
    CONNECTED: 'connected',
    CONNECTING: 'connecting',
    ENDED: 'ended',
    ERROR: 'error',
    INCOMING: 'incoming',
    INIT: 'init',
    MISSED: 'missed',
    PENDING: 'pending',
  },
  connectionStateTypes: {
    CONNECTED: 'connected',
    CONNECTING: 'connecting',
    DISCONNECTED: 'disconnected',
    HOLD: 'hold',
    INIT: 'init',
  },
  // "system" and "error" is not in the connect object, but appears in practice.
  agentStateTypes: {
    INIT: 'init',
    ROUTABLE: 'routable',
    NOT_ROUTABLE: 'not_routable',
    OFFLINE: 'Offline',
    SYSTEM: 'system',
    ERROR: 'error',
    BUSY: 'Busy',
    AFTER_CALL_WORK: 'AfterCallWork',
    AVAILABLE: 'Available',
    PENDING_BUSY: 'PendingBusy',
  },
  agentErrorTypes: {
    AGENT_HUNG_UP: 'AgentHungUp',
    BAD_ADDRESS_AGENT: 'BadAddressAgent',
    BAD_ADDRESS_CUSTOMER: 'BadAddressCustomer',
    DEFAULT: 'Default',
    ERROR: 'Error',
    FAILED_CONNECT_AGENT: 'FailedConnectAgent',
    FAILED_CONNECT_CUSTOMER: 'FailedConnectCustomer',
    LINE_ENGAGED_AGENT: 'LineEngagedAgent',
    LINE_ENGAGED_CUSTOMER: 'LineEngagedCustomer',
    MISSED_CALL_AGENT: 'MissedCallAgent',
    MISSED_CALL_CUSTOMER: 'MissedCallCustomer',
    MULTIPLE_CCP_WINDOWS: 'MultipleCcpWindows',
    REALTIME_COMMUNICATION_ERROR: 'RealtimeCommunicationError',
  },
  stateObjects: {
    AGENT: 'agent',
    CONTACT: 'contact',
    PRIMARYCONNECTION: 'primary_connection',
    SECONDARYCONNECTION: 'secondary_connection',
  },
  paymentDetailsStates: {
    EXIT: 'exit',
    EMPTY: 'empty',
    HELD: 'held',
    WAIT: 'wait',
    DISPLAY: 'display',
    ERROR: 'error',
    DROP: 'drop',
  },
  recordingDetailsStates: {
    EMPTY: 'empty',
    RECORDING: 'recording',
    SUSPENDED: 'suspended',
    ACTION_SUSPEND: 'suspend', // REQUIRED BY API
    ACTION_RESUME: 'resume', // REQUIRED BY API
    WAITING_SUSPEND: 'waiting_suspend',
    WAITING_RESUME: 'waiting_resume',
    ERROR_SUSPEND: 'error_suspend',
    ERROR_RUSUME: 'error_rusume',
    REQUEST_SUSPEND: 'request_suspend',
    REQUEST_RUSUME: 'request_resume',
  },
};
export default States;
